import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Chat from './components/Chat';
import Contacts from './components/Contacts';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';
import Signup from './components/Signup';
import Landing from './components/Landing';
import './styles/App.css';

const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <LoadingProvider>
        <AuthProvider>
          <div className="app">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/register" element={<Signup />} />
              <Route path="/contacts" element={
                <PrivateRoute>
                  <Contacts />
                </PrivateRoute>
              } />
              <Route path="/chat/:roomId" element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              } />
              <Route path="/chat" element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              } />
              <Route path="/" element={<Landing />} />
            </Routes>
          </div>
        </AuthProvider>
      </LoadingProvider>
    </Router>
  );
}

export default App;
